import React from 'react';
import Grid from 'components/atoms/Grid';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function MaterialsSection({ materials, setMaterials, form }) {
  const addCard = () => {
    setMaterials(prev => [
      ...prev,
      {
        image: null,
        name: '',
        description: '',
        materialsSubheading: '',
        materialsSubheadingOptions: [{ value: '' }],
        characteristicHeading: '',
        characteristicOption: '',
      },
    ]);
  };

  const removeCard = index => {
    setMaterials(prev => prev.filter((_, i) => i !== index));
  };

  const updateImage = (materialIndex, file) => {
    setMaterials(prev => {
      const updated = [...prev];
      updated[materialIndex].image = file;
      return updated;
    });
  };

  const updateName = (materialIndex, name) => {
    setMaterials(prev => {
      const updated = [...prev];
      updated[materialIndex].name = name;
      return updated;
    });
  };

  const updateDescription = (materialIndex, description) => {
    setMaterials(prev => {
      const updated = [...prev];
      updated[materialIndex].description = description;
      return updated;
    });
  };

  const updateSubheading = (materialIndex, materialsSubheading) => {
    setMaterials(prev => {
      const updated = [...prev];
      updated[materialIndex].materialsSubheading = materialsSubheading;
      return updated;
    });
    form.setFieldsValue({
      [`materialsSubheading_${materialIndex + 1}`]: materialsSubheading,
    });
  };

  const updateCharacteristicHeading = (materialIndex, characteristicHeading) => {
    setMaterials(prev => {
      const updated = [...prev];
      updated[materialIndex].characteristicHeading = characteristicHeading;
      return updated;
    });
    form.setFieldsValue({
      [`material_characteristicHeading_${materialIndex + 1}`]: characteristicHeading,
    });
  };

  const updateCharacteristicOption = (materialIndex, characteristicOption) => {
    setMaterials(prev => {
      const updated = [...prev];
      updated[materialIndex].characteristicOption = characteristicOption;
      return updated;
    });
  };

  // Thickness handlers
  const addThickness = materialIndex => {
    setMaterials(prev => {
      const updated = [...prev];
      const currentMaterial = updated[materialIndex];
      updated[materialIndex] = {
        ...currentMaterial,
        materialsSubheadingOptions: [...currentMaterial.materialsSubheadingOptions, { value: '' }],
      };
      return updated;
    });
  };

  const removeThickness = (materialIndex, thicknessIndex) => {
    setMaterials(prev => {
      const updated = [...prev];
      const currentMaterial = updated[materialIndex];
      updated[materialIndex] = {
        ...currentMaterial,
        materialsSubheadingOptions: currentMaterial.materialsSubheadingOptions.filter((_, i) => i !== thicknessIndex),
      };
      return updated;
    });
  };

  const updateThickness = (materialIndex, thicknessIndex, value) => {
    setMaterials(prev => {
      const updated = [...prev];
      updated[materialIndex].materialsSubheadingOptions[thicknessIndex].value = value;
      return updated;
    });
  };

  return (
    <div className="materials-holder">
      <div className="head">
        <span className="label">Materials</span>
        <button className="add-more" type="button" onClick={addCard}>
          Add Material <i className="material-icons-outlined">add</i>
        </button>
      </div>
      <Grid xs={1} lg={2} colGap={10} rowGap={20}>
        {materials?.map((material, materialIndex) => (
          <div className="card" key={materialIndex}>
            {materials.length > 1 && (
              <button className="remove-btn" type="button" onClick={() => removeCard(materialIndex)}>
                <i className="material-icons-outlined">close</i>
              </button>
            )}
            <Form.Item
              name={`material_image_${materialIndex + 1}`}
              type="chooseFile"
              small
              value={material?.image}
              displayFile={material?.image?.preview || material?.image || null}
              onChange={file => updateImage(materialIndex, file)}
              rules={[{ required: false, message: `Select material image` }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Material Name"
              name={`material_name_${materialIndex + 1}`}
              type="text"
              sm
              value={material?.name}
              onChange={e => updateName(materialIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter material name' }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Material Description"
              name={`material_description_${materialIndex + 1}`}
              type="text"
              sm
              value={material?.description}
              onChange={e => updateDescription(materialIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter material description' }]}>
              <Field />
            </Form.Item>
            <div className="thickness-section">
              <div className="thickness-header">
                <Form.Item
                  label="Material SubHeading"
                  name={`materialsSubheading_${materialIndex + 1}`}
                  type="text"
                  sm
                  value={material?.materialsSubheading}
                  onChange={e => updateSubheading(materialIndex, e.target.value)}
                  rules={[{ required: false, message: 'Enter material subheading' }]}>
                  <Field />
                </Form.Item>
                {/* <span className="label">Thickness options</span> */}
                <button
                  className="add-more"
                  type="button"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    addThickness(materialIndex);
                  }}>
                  Add Option <i className="material-icons-outlined">add</i>
                </button>
              </div>
              <Grid xs={1} lg={2} colGap={10} rowGap={10}>
                {material?.materialsSubheadingOptions?.map((thickness, thicknessIndex) => (
                  <div key={thicknessIndex} className="thickness-item">
                    <Form.Item
                      name={`thickness_${materialIndex + 1}_${thicknessIndex + 1}`}
                      type="text"
                      placeholder="Enter option"
                      sm
                      noMargin
                      value={thickness?.value}
                      onChange={e => updateThickness(materialIndex, thicknessIndex, e.target.value)}
                      rules={[{ required: false, message: 'Enter option' }]}>
                      <Field />
                    </Form.Item>
                    {material.materialsSubheadingOptions.length > 1 && (
                      <button
                        className="remove-thickness-btn"
                        type="button"
                        onClick={() => removeThickness(materialIndex, thicknessIndex)}>
                        <i className="material-icons-outlined">close</i>
                      </button>
                    )}
                  </div>
                ))}
              </Grid>
            </div>
            <Form.Item
              label="Characteristics Heading"
              name={`material_characteristicHeading_${materialIndex + 1}`}
              type="text"
              sm
              value={material?.characteristicHeading}
              onChange={e => updateCharacteristicHeading(materialIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter characteristics heading' }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Characteristic Options"
              name={`characteristicOption_${materialIndex + 1}`}
              type="text"
              sm
              value={material?.characteristicOption}
              onChange={e => updateCharacteristicOption(materialIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter best for' }]}>
              <Field />
            </Form.Item>
          </div>
        ))}
      </Grid>
    </div>
  );
}

export default MaterialsSection;
